import React, { useState } from "react"

import "./Sign.css"
import kakaoIcon from "../../assets/loginKakao.svg"

import Nav from "../../component/Nav/Nav"
import Footer from "../../component/Footer/Footer"
import SubBanner from "../../component/SubBanner/SubBanner"
import TermsModal from "../../component/Modal/TermsModal"
// import {sendRequest} from "../../api/client";
import {sendRequest, storeData, validateEmail, validatePhone} from "../../common";
import {useNavigate} from "react-router-dom";
import KakaoLogin from "react-kakao-login";
import {Button} from "antd";

const token = 'c03561d986ff457807d653d3d1d9e536'

function SignUp() {
	const navigate = useNavigate()

	const [termsOpen, setTermsOpen] = useState(false)
	const showTerms = () => {
		setTermsOpen(true)
	}

	const [email, setEmail] = useState('')
	const [name, setName] = useState('')
	const [phone, setPhone] = useState('')
	const [password, setPassword] = useState('')
	const [passwordConfirm, setPasswordConfirm] = useState('')
	const [isTermAgree, setIsTermAgree] = useState(false)
	const [isExpert, setIsExpert] = useState(true)

	const [certify, setCertify] = useState(false)
	const [certifyNumber, setCertifyNumber] = useState('')
	const [isCertified, setIsCertified] = useState(false)
	const [code, setCode] = useState('')

	const signUp = () => {
		if (!email?.length || !name?.length || !phone?.length || !password?.length || !passwordConfirm?.length) {
			alert('이메일, 이름, 휴대폰 번호, 비밀번호를 모두 입력해 주세요.')
			return
		}

		if (!isCertified) {
			alert('휴대폰 인증을 완료해 주세요.')
			return
		}

		if (!isTermAgree) {
			alert('개인정보 수집 및 이용에 동의해 주세요.')
			return
		}

		sendRequest('accounts/email/registration/', 'POST', {
			email,
			name,
			password1: password,
			password2: passwordConfirm,
			isExpert,
			phone
		}, data => {
			if (isExpert) {
				alert('가입되었습니다. 일주일 이내로 자격요건을 마이페이지에서 수정하여 승인요청 해주세요')
			} else {
				alert('가입되었습니다. 환영합니다.')
			}
			storeData('accessToken', data?.tokens?.accessToken)
			storeData('user', data?.user)
			// alert('로그인 되었습니다. 홈 화면으로 이동합니다.')
			navigate('/')
			// navigate('/sign-in')
		}, (data, code) => {
			console.log(data)
			if (data?.msg?.indexOf('email') !== -1) {
				alert('이미 가입된 이메일 입니다.')
			} else if (data?.msg?.indexOf('phone') !== -1){
				alert('휴대폰 번호 형식을 확인해 주세요.')
			} else {
				alert(data?.msg)
			}

			// alert(data?.msg)
		})
	}

	const sendSms = () => {
		if (!phone?.length) {
			alert('휴대폰 번호를 입력해 주세요.')
			return
		}

		if (!phone?.startsWith('010') || phone.length !== 11) {
			alert('잘못된 휴대폰 번호입니다. 다시 입력해주세요.')
			return
		}

		sendRequest(`accounts/phone-auth/?phone=${phone}`, 'GET', null, data => {
			setCertify(true)
			setCode(data?.code)
			alert('인증번호가 전송되었습니다. 4자리 코드를 입력해 주세요.')
		}, (data, code) => {
			alert(data?.msg)
		})
	}

	const checkAuth = () => {
		if (certifyNumber?.toString() === code?.toString()) {
			setCertify(false)
			setCertifyNumber('')
			setIsCertified(true)
			alert('인증이 완료 되었습니다.')
		} else {
			alert('인증번호를 확인해주세요.')
		}
		// sendRequest(`accounts/phone-auth/`, 'POST', {
		// 	code: certifyNumber
		// }, data => {
		// 	setCertify(false)
		// 	setCertifyNumber('')
		// 	setIsCertified(true)
		// 	alert('인증이 완료 되었습니다.')
		// }, (data, code) => {
		// 	alert('인증번호를 확인해주세요.')
		// })
	}

	const UseLoginForm = ({render}) => (
		<KakaoLogin
			token={token}
			onSuccess={({response, profile}) => {
				sendRequest('accounts/social/login/', 'POST', {
					snsType: '카카오',
					snsId: profile?.id,
					email: null,
					isExpert
				}, data => {
					// console.log('success')
					// console.log(data)
					storeData('accessToken', data?.tokens?.accessToken)
					storeData('user', data?.user)
					if (isExpert) {
						alert('가입되었습니다. 일주일 이내로 자격요건을 마이페이지에서 수정하여 승인요청 해주세요')
					} else {
						alert('가입되었습니다. 환영합니다.')
					}
					navigate('/')
				}, (data, code) => {
					console.log(data, code)
				})
			}}
			onFail={console.error}
			onLogout={console.info}
			useLoginForm
			render={render}
		/>
	);

	return (
		<>
			<Nav />
			<SubBanner title={"회원가입"} firstText={"인컬리지에서 다양한 서비스를 경험해보세요."} />
			<div className="container">
				<div className="cardContent signCard">
					<section>
						<form className="cardForm" name="signUp">
							<div className="memberWrap">
								<button
									className={isExpert ? "active" : null}
									type="button"
									onClick={() => setIsExpert(true)}
								>
									전문가 회원
								</button>
								<button
									className={!isExpert ? "active" : null}
									type="button"
									onClick={() => setIsExpert(false)}
								>
									일반 회원
								</button>
							</div>
							<div className="formWrap">
								<div className="formItem">
									<div className="formHead">
										<span className="formName">이메일</span>
									</div>
								</div>
								<div className="formItem">
									<div className="formBody">
										<span>
											<input type="email" name="emailId" placeholder="이메일을 입력해주세요" required value={email} onChange={e => setEmail(e.target.value)} onBlur={() => validateEmail(email, setEmail)}/>
										</span>
									</div>
								</div>
							</div>
							<div className="formWrap">
								<div className="formItem">
									<div className="formHead">
										<span className="formName">이름</span>
									</div>
								</div>
								<div className="formItem">
									<div className="formBody">
										<span>
											<input type="text" name="userName" placeholder="이름을 입력해주세요" required value={name} onChange={e => setName(e.target.value)}/>
										</span>
									</div>
								</div>
							</div>
							<div className="formWrap">
								<div className="formItem">
									<div className="formHead">
										<span className="formName">휴대폰 번호</span>
									</div>
								</div>
								<div className="formItem">
									<div className="formBody">
										<span>
											<input type="text" name="userPhone" placeholder="휴대폰 번호를 입력해주세요" required value={phone} onChange={e => setPhone(e.target.value?.replace(/[^\d]/,''))} onBlur={() => validatePhone(phone, setPhone)} maxLength={12}/>
										</span>
										{!certify &&
											<span>
												<Button
													style={{marginTop: 10}}
													onClick={sendSms}
												>
													인증번호 보내기
												</Button>
											</span>
										}
										{certify &&
											<div style={{marginTop: 10}}>
												<input type="text" name="certifyNumber" placeholder="인증 번호를 입력해주세요" required value={certifyNumber} onChange={e => setCertifyNumber(e.target.value)}/>

												<Button
													style={{marginTop: 10}}
													onClick={checkAuth}
												>
													인증하기
												</Button>
											</div>
										}
									</div>
								</div>
							</div>
							<div className="formWrap">
								<div className="formItem">
									<div className="formHead">
										<span className="formName">비밀번호</span>
									</div>
								</div>
								<div className="formItem">
									<div className="formBody">
										<span className="formPW">
											<input
												type="password"
												name="password"
												placeholder="비밀번호를 입력해주세요"
												required
												value={password}
												onChange={e => setPassword(e.target.value)}
											/>
											<input
												type="password"
												name="passwordCheck"
												placeholder="비밀번호를 확인해주세요"
												required
												value={passwordConfirm}
												onChange={e => setPasswordConfirm(e.target.value)}
											/>
										</span>
									</div>
								</div>
							</div>
							<div className="formWrap">
								<div className="formCheckbox">
									<input type="checkbox" id="psInfo" required checked={isTermAgree} onChange={e => setIsTermAgree(e.target.checked)}/>
									<label htmlFor="psInfo"></label>
									<span>
										<b onClick={showTerms}>개인정보 수집 및 이용</b>에 동의합니다.
									</span>
								</div>
							</div>
							<div className="buttonWrap">
								<div className="submitBtn" onClick={signUp}>
									회원가입
								</div>
							</div>
							<div className="snsWrap">
								<span>소셜 아이디로 간편 가입</span>
								<UseLoginForm
									render={({onClick}) => (
										<button type="button" className="kakaoBtn" onClick={onClick}>
											<img src={kakaoIcon} alt="카카오 아이콘" /> 카카오 로그인
										</button>
									)}
								/>
								{/*<button type="button" className="kakaoBtn">*/}
								{/*	<img src={kakaoIcon} alt="카카오 아이콘" /> 카카오로 시작하기*/}
								{/*</button>*/}
							</div>
						</form>
					</section>
				</div>
			</div>

			{termsOpen && (
				<TermsModal
					setTermsOpen={setTermsOpen}
					title={"개인정보 수집 및 이용에 관한 안내"}
					text={
						"제 3조 개인정보의 제3자 제공에 관한 사항 \n 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다. \n 개인정보를 제3자에게 제공하는 경우 다음의 항목을 이용자에게 알린 후 동의를 받겠습니다. \n "
					}
				/>
			)}

			<Footer />
		</>
	)
}

export default SignUp
